import { LandingPage } from "./components/LandingPage";
import { WelcomeScreen } from "./components/WelcomeScreen";
import { LifePriorities } from "./components/LifePriorities";
import { SevenStories } from "./components/SevenStories";
import { WorkStyleCalibration } from "./components/WorkStyleCalibration";
import { BfiProfile } from "./components/BfiProfile";
import { PersonalValues } from "./components/PersonalValues";
import { CoreProjects } from "./components/CoreProjects";
import { OnboardingComplete } from "./components/OnboardingComplete";
import { Dashboard } from "./components/Dashboard";
import { GeneratedSchedule } from "./components/GeneratedSchedule";
import { LeaderDashboard } from "./components/LeaderDashboard";
export default class App {
    constructor(rootContainer) {
        this.appElement = null; // This will be the #app div
        this.currentStep = 0;
        this.currentComponent = null;
        this.rootContainer = rootContainer;
        window.appInstance = this;
        this.renderLayout(); // Render the main structure immediately
        this.render(); // Render the first component
    }
    renderLayout() {
        // This structure now perfectly mirrors your original body content
        this.rootContainer.innerHTML = `
            <main class="app-main">
                <div id="app">
                    <!-- Components will be rendered here -->
                    <div class="loader"></div>
                </div>
            </main>
        `;
        // Find the #app element where components will be rendered
        this.appElement = this.rootContainer.querySelector('#app');
    }
    render() {
        if (!this.appElement) {
            console.error("App element not found. Cannot render component.");
            return;
        }
        const scrollY = window.scrollY;
        switch (this.currentStep) {
            case 0:
                this.currentComponent = new LandingPage(this);
                break;
            case 1:
                this.currentComponent = new WelcomeScreen(this);
                break;
            case 2:
                this.currentComponent = new LifePriorities(this);
                break;
            case 3:
                this.currentComponent = new SevenStories(this);
                break;
            case 4:
                this.currentComponent = new WorkStyleCalibration(this);
                break;
            case 5:
                this.currentComponent = new BfiProfile(this);
                break;
            case 6:
                this.currentComponent = new PersonalValues(this);
                break;
            case 7:
                this.currentComponent = new CoreProjects(this);
                break;
            case 8:
                this.currentComponent = new OnboardingComplete(this);
                break;
            case 9:
                this.currentComponent = new Dashboard(this);
                break;
            case 10:
                this.currentComponent = new GeneratedSchedule(this);
                break;
            case 11:
                this.currentComponent = new LeaderDashboard(this);
                break;
            default:
                this.appElement.innerHTML = `<div class="card"><h1>Prototype Complete</h1><p>You have finished the demo.</p></div>`;
                return;
        }
        this.appElement.innerHTML = this.currentComponent.render();
        this.currentComponent.attachEventListeners();
        window.scrollTo(0, scrollY);
    }
    // --- Other methods remain unchanged ---
    renderCurrentView() {
        if (this.currentComponent && 'renderCurrentViewOnly' in this.currentComponent) {
            this.currentComponent.renderCurrentViewOnly();
        }
        else {
            console.warn("renderCurrentView called on a component without a dedicated method. Performing full render.");
            this.render();
        }
    }
    nextStep() {
        this.currentStep++;
        this.render();
    }
    returnToDashboard() {
        this.currentStep = 9;
        this.render();
    }
    goToLeaderView() {
        this.currentStep = 11;
        this.render();
    }
}
